var _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJumpToUrlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8596 20C39.0931 15.2175 33.9223 12 28 12C22.0777 12 16.9069 15.2175 14.1404 20H16.5093C18.2079 17.5645 20.6611 15.6944 23.5299 14.7285C22.5235 16.0871 21.6801 17.8915 21.0702 20H23.1607C23.444 19.1142 23.7709 18.3032 24.132 17.5811C25.4734 14.8975 26.9566 14 28 14C29.0435 14 30.5266 14.8975 31.868 17.5811C32.2292 18.3032 32.5561 19.1142 32.8394 20H34.9298C34.32 17.8915 33.4765 16.0871 32.4702 14.7285C35.339 15.6944 37.7921 17.5645 39.4908 20H41.8596Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8596 36H39.4908C37.7921 38.4355 35.339 40.3056 32.4702 41.2715C33.4765 39.9129 34.32 38.1085 34.9298 36H32.8394C32.5561 36.8858 32.2292 37.6968 31.868 38.4189C30.5266 41.1025 29.0435 42 28 42C26.9566 42 25.4734 41.1025 24.132 38.4189C23.7709 37.6968 23.444 36.8858 23.1607 36H21.0702C21.6801 38.1085 22.5235 39.9129 23.5299 41.2715C20.6611 40.3056 18.2079 38.4355 16.5093 36H14.1404C16.9069 40.7825 22.0777 44 28 44C33.9223 44 39.0931 40.7825 41.8596 36Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24L12.2827 25.134L13.9018 32H15.3858L16.404 25.9607H16.4806L17.515 32H18.9909L20.61 25.134L20.8494 24H19.4107L19.2415 24.8009L18.3539 28.5649L17.6568 24.4943H15.2246L14.5385 28.5638L13.647 24.7836L13.4517 24H12Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5753 24L23.858 25.134L25.4771 32H26.961L27.9793 25.9607H28.0559L29.0902 32H30.5662L32.1852 25.134L32.4247 24H30.9859L30.8168 24.8009L29.9292 28.5649L29.2321 24.4943H26.7999L26.1137 28.5638L25.2223 24.7836L25.027 24H23.5753Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1506 24L35.4333 25.134L37.0523 32H38.5363L39.5545 25.9607H39.6312L40.6655 32H42.1414L43.7605 25.134L44 24H42.5612L42.3921 24.8009L41.5045 28.5649L40.8073 24.4943H38.3751L37.689 28.5638L36.7976 24.7836L36.6023 24H35.1506Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpToUrlIcon);
export default __webpack_public_path__ + "static/media/jump_to_URL_icon.bfc780c6.svg";
export { ForwardRef as ReactComponent };